import React from 'react';

// Rivets + silicone needed for the job (materials / crew only — not priced to the customer).
export const FixingsCard = ({ fixings }) => {
  if (!fixings) return null;
  const { rivets, rivet_sku: sku, clear_tubes: clear, modified_tubes: modified, modified_colour: colour, rows = [] } = fixings;
  return (
    <div className="bg-white border border-slate-200 rounded-md p-3" data-testid="materials-fixings-card">
      <h3 className="text-sm font-bold text-slate-800 mb-1">Fixings — rivets &amp; silicone</h3>
      {rows.length === 0 ? (
        <p className="text-xs text-slate-500" data-testid="materials-fixings-empty">No rivets or silicone needed for the items on this job (or their fixings aren't set up yet in Admin → Fixings).</p>
      ) : (
        <>
          <div className="flex flex-wrap gap-2 text-xs mb-2">
            <span className="px-2 py-1 rounded bg-slate-100" data-testid="materials-fixings-rivets"><b>{rivets}</b> × {sku}</span>
            <span className="px-2 py-1 rounded bg-slate-100" data-testid="materials-fixings-clear"><b>{clear}</b> tube{clear === 1 ? '' : 's'} clear roofing silicone</span>
            <span className="px-2 py-1 rounded bg-slate-100" data-testid="materials-fixings-modified"><b>{modified}</b> tube{modified === 1 ? '' : 's'} modified silicone{colour ? ` (${colour})` : ''}</span>
          </div>
          <table className="w-full text-[11px]">
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className="border-t" data-testid={`materials-fixings-row-${i}`}>
                  <td className="py-0.5 pr-2">{r.item}</td><td className="pr-2 text-slate-500">{r.basis}</td>
                  <td className="pr-2">{r.rivets} rivets</td><td>{r.silicone_ml} ml {r.silicone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};
